'use client';

import { useTenantSelection } from '@payloadcms/plugin-multi-tenant/client';
import { PopupList } from '@payloadcms/ui';

import ExportJourney from '../Modals/ExportModal/ExportModal';
import ImportJourney from '../Modals/ImportModal/ImportModal';
import ExportButton from './ExportButton';
import ImportButton from './ImportButton';

const ListItemsButtonsGroup = () => {
  const { selectedTenantID } = useTenantSelection();

  return (
    <>
      <PopupList.ButtonGroup>
        <ExportButton disabled={!selectedTenantID} />
        <ImportButton disabled={!selectedTenantID} />
      </PopupList.ButtonGroup>
      <ExportJourney />
      <ImportJourney />
    </>
  );
};

export default ListItemsButtonsGroup;
